import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * The route for the admin pages - JSM audit logs page.
 */
export const adminPagesJsmAuditLogsRoute: InvariantJiraRoute = {
	name: 'global-settings-products-jsm-audit-logs',
	path: '/jira/settings/products/jira-service-management-audit-logs',
	exact: true,
};
